import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateSensorExclusionMutationVariables = Types.Exact<{
  input: Types.CreateSensorExclusionInput;
}>;


export type CreateSensorExclusionMutationPage = { readonly __typename?: 'RootMutationType', readonly createSensorExclusion: { readonly __typename?: 'YalperSensorExclusion', readonly id: string } };

export type DeleteSensorExclusionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteSensorExclusionMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteSensorExclusion: boolean };


export const CreateSensorExclusionDocument = gql`
    mutation CreateSensorExclusion($input: CreateSensorExclusionInput!) {
  createSensorExclusion(input: $input) {
    id
  }
}
    `;
export type CreateSensorExclusionMutationFn = Apollo.MutationFunction<CreateSensorExclusionMutationPage, CreateSensorExclusionMutationVariables>;

/**
 * __useCreateSensorExclusionMutation__
 *
 * To run a mutation, you first call `useCreateSensorExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSensorExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSensorExclusionMutation, { data, loading, error }] = useCreateSensorExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSensorExclusionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSensorExclusionMutationPage, CreateSensorExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSensorExclusionMutationPage, CreateSensorExclusionMutationVariables>(CreateSensorExclusionDocument, options);
      }
export type CreateSensorExclusionMutationHookResult = ReturnType<typeof useCreateSensorExclusionMutation>;
export type CreateSensorExclusionMutationResult = Apollo.MutationResult<CreateSensorExclusionMutationPage>;
export type CreateSensorExclusionMutationOptions = Apollo.BaseMutationOptions<CreateSensorExclusionMutationPage, CreateSensorExclusionMutationVariables>;
export const DeleteSensorExclusionDocument = gql`
    mutation DeleteSensorExclusion($id: ID!) {
  deleteSensorExclusion(id: $id)
}
    `;
export type DeleteSensorExclusionMutationFn = Apollo.MutationFunction<DeleteSensorExclusionMutationPage, DeleteSensorExclusionMutationVariables>;

/**
 * __useDeleteSensorExclusionMutation__
 *
 * To run a mutation, you first call `useDeleteSensorExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSensorExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSensorExclusionMutation, { data, loading, error }] = useDeleteSensorExclusionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSensorExclusionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSensorExclusionMutationPage, DeleteSensorExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSensorExclusionMutationPage, DeleteSensorExclusionMutationVariables>(DeleteSensorExclusionDocument, options);
      }
export type DeleteSensorExclusionMutationHookResult = ReturnType<typeof useDeleteSensorExclusionMutation>;
export type DeleteSensorExclusionMutationResult = Apollo.MutationResult<DeleteSensorExclusionMutationPage>;
export type DeleteSensorExclusionMutationOptions = Apollo.BaseMutationOptions<DeleteSensorExclusionMutationPage, DeleteSensorExclusionMutationVariables>;